<template>
  <SelLetterManage></SelLetterManage>
</template>
<script>
import SelLetterManage from '@/views/offlineClass/selLetterManage/index.vue';
export default {
  name: 'centerSelectClassLetterManage',
  props: {},
  components: { SelLetterManage },
  data() {
    return {
    };
  },
  created() { },
  methods: {}
}
</script>
<style lang='scss' scoped>

</style>